<template>
  <BlFlexContainerMv direction="column" align-items="flex-start" justify-content="space-between" padding="16px" class="reviewer">
    <BlFlexContainerMv direction="row" align-items="center" justify-content="space-between" width="100%">
      <div class="flex items-center space-x-2">
        <BlAvatarAv size="small" class="reviewer__avatar">
          <img :src="data.user.avatar_url" class="qa-reviewer-avatar" alt="image" />
        </BlAvatarAv>
        <BlTextAv variation="caption-12" color="secondary" weight="medium" class="reviewer__name">{{ data.user.name }}</BlTextAv>
      </div>

      <div class="flex items-center">
        <IcoStarMinor v-for="index in Math.floor(data.rating)" :key="index" class="transform scale-90" color="#FFA726" />
      </div>
    </BlFlexContainerMv>
    <BlTextAv variation="body-14" class="reviewer__comment">{{ data.review }}</BlTextAv>
  </BlFlexContainerMv>
</template>

<script>
import {IcoStarMinor} from '@bukalapak/bazaar-visual-next';
import {BlAvatarAv, BlTextAv, BlFlexContainerMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaReview',
  components: {
    IcoStarMinor,
    BlAvatarAv,
    BlTextAv,
    BlFlexContainerMv,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.reviewer {
  border-bottom: 1px solid #e8eaef;
  &__comment {
    margin-top: 12px;
  }
}
</style>
